import { render, staticRenderFns } from "./FilterSort.vue?vue&type=template&id=0f508d7c&scoped=true"
import script from "./FilterSort.vue?vue&type=script&lang=js"
export * from "./FilterSort.vue?vue&type=script&lang=js"
import style0 from "./FilterSort.vue?vue&type=style&index=0&id=0f508d7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f508d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f508d7c')) {
      api.createRecord('0f508d7c', component.options)
    } else {
      api.reload('0f508d7c', component.options)
    }
    module.hot.accept("./FilterSort.vue?vue&type=template&id=0f508d7c&scoped=true", function () {
      api.rerender('0f508d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/filter/filterMain/FilterSort.vue"
export default component.exports